import React, { useState, useEffect, useContext } from 'react';
import { useTheme } from '@material-ui/styles';
import { useStyles } from '../styles';

import { Typography } from '@material-ui/core';

import Crud from '../crud';
import Quickcrumbs from '../../global/Quickcrumbs';


const TicketLevels = props => {


    const theme = useTheme();
    const styles = useStyles(theme);

    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>

                <Quickcrumbs 
                    crumbs={[
                        {
                            name: 'Settings',
                            route: '/settings'
                        },
                        {
                            name: 'Ticket Levels',
                            route: '/settings/ticket_levels'
                        }
                    ]}
                    history={props.history}
                />


                <div className={styles.taskbar}>

                    <Typography variant="h4">Ticket Levels</Typography>

                </div>
                
                <Typography color="textSecondary" variant="caption" className={styles.space}>These are the mains levels a fault can be pin pointed to. Adding any further levels would require additional coding to control what a ticket should show.</Typography>

                <Crud
                    uri='ticket_effect'
                    idCol='id_ticket_effect'
                    displayColumns={[
                        { 
                            name: 'ticket_effect_name', 
                            display_name: 'Level',
                            type: 'string',
                            editable: true,
                            required: true
                        },
                        { 
                            name: 'disabled', 
                            type: 'boolean',
                            editable: true
                        }
                    ]}
                />

            </div>
        </div>
    )

}

export default TicketLevels
